/**
 * Joins conditional class names.
 *
 * Deliberately dependency free. If a real Tailwind conflict-resolution problem
 * appears (two utilities targeting the same CSS property), add `tailwind-merge`
 * with an architectural note rather than pre-installing it.
 */
export function cn(...values) {
    const out = [];
    for (const value of values) {
        if (value === null || value === undefined || value === false || value === '') {
            continue;
        }
        if (Array.isArray(value)) {
            const nested = cn(...value);
            if (nested) {
                out.push(nested);
            }
            continue;
        }
        out.push(String(value));
    }
    return out.join(' ');
}
//# sourceMappingURL=cn.js.map